const MIN_SEARCH_LENGTH = 3;

export const GlobalFilter = ({ filter, setFilter, debouncedResults, onSearch }) => {

    const handleChange = (e) => {
        setFilter(e.target.value);     // input ko turant update karega
        debouncedResults(e);           // debounce search trigger karega
    };

    const searchValue = (filter || "").trim();
    const canSearch = searchValue.length >= MIN_SEARCH_LENGTH;

    const handleSearchClick = () => {
        if (canSearch) onSearch(searchValue);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && onSearch) handleSearchClick();
    };

    return (
        <div className="customTable__searchFilter">
            <label>Search:</label>
            <input
                className="form-control"
                maxLength="40"
                type="text"
                value={filter || ""}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
            {onSearch && (
                <button
                    type="button"
                    className="btn btn-primary"
                    style={{ marginLeft: "10px" }}
                    onClick={handleSearchClick}
                    disabled={!canSearch}
                    title={canSearch ? "" : `Enter at least ${MIN_SEARCH_LENGTH} characters`}
                >
                    Search
                </button>
            )}
        </div>
    );
};
